<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="roles"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="nuevo()">Nuevo</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                @click="editarItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                tab
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.condicion`]="{ item }">
          <v-chip :color="getColorCondicion(item.condicion)" dark>
            <div v-if="item.condicion"><span>Activo</span></div>
            <div v-else><span>Inactivo</span></div>
          </v-chip>
        </template>
      </v-data-table>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>
    </v-flex>

    <v-dialog v-model="dialog" max-width="800" persistent scrollable>
      <v-card>
        <v-card-title>Rol</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-1">
              <v-text-field
                v-model="nombre"
                label="Nombre"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="descripcion"
                label="Descripción"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="pb-3 px-3">
              <v-checkbox
                v-model="condicion"
                label="Estado"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="auto" class="pb-3 px-3">
              <v-checkbox
                v-model="ver_mis_asistencias"
                label="Ver mis asistencia"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-divider class="my-3"></v-divider>

          <h2>Opciones</h2>
          <v-data-table
            :headers="headers_acciones"
            :items="items_acciones"
            dense
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.asignar`]="{ item }">
              <v-checkbox
                v-model="item.estatus"
                dense
                hide-details
                class="pa-0 ma-0"
              >
                tab
              </v-checkbox>
            </template>
          </v-data-table>

          <v-row>
            <v-col>
              <h2>Permisos módulos</h2>
              <v-row>
                <v-col cols="6" v-for="(item, index) in modulos" :key="index">
                  <v-btn rounded elevation="3">
                    <v-checkbox
                      :label="item.nombre"
                      v-model="item.estado"
                      @click="removidos(item)"
                    ></v-checkbox>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cerrarDialog()" color="primary" text>Cancelar</v-btn>
          <v-btn v-if="bandera == 1" color="primary" text @click="crearRol()"
            >Guardar</v-btn
          >
          <v-btn
            v-if="bandera != 1"
            color="primary"
            text
            @click="actualizarRol()"
            >Actualizar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,
      roles: [],
      headers: [
        { text: "Nombre", value: "nombre", sortable: false },
        { text: "Descripcion", value: "descripcion", sortable: false },
        { text: "Estado", value: "condicion", sortable: false },
        { text: "Opciones", value: "actions", sorteable: false },
      ],
      search: "",
      id_rol: 0,
      nombre: "",
      descripcion: "",
      condicion: false,
      overlay: true,
      modulos: [],
      permisos: [],
      bandera: 0,
      selections: [],
      itemsRemovidos: [],
      headers_acciones: [
        { text: "Acciones", value: "nombre" },
        { text: "Asignar", value: "asignar" },
      ],
      items_acciones: [],
      acciones_seleccionadas: [],
      ver_mis_asistencias: false
    };
  },
  created() {
    this.listar();
    this.listarAcciones();
  },
  methods: {
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Roles/Listar", configuracion)
        .then(function (response) {
          me.roles = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.overlay = false;
        });
    },
    nuevo() {
      this.listarModulos();
      this.listarAcciones();

      this.bandera = 1;
      this.dialog = true;
    },
    async listarModulos() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      await axios
        .get("api/Accesos/Listar", configuracion)
        .then((response) => {
          response.data.forEach((element) => {
            this.modulos.push({
              id_permiso: 0,
              id_modulo: element.id_modulo,
              nombre: element.nombre,
              estado: false,
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listarAcciones() {
      axios.get("api/Acciones/Listar").then((response) => {
        response.data.forEach((element) => {
          this.items_acciones.push({
            id_acciones: element.id_acciones,
            nombre: element.nombre,
            nombre_identificador: element.nombre_identificador,
            estatus: false,
          });
        });
      });
    },
    editarItem(item) {
      this.id_rol = item.idRol;
      this.nombre = item.nombre;
      this.descripcion = item.descripcion;
      this.condicion = item.condicion;
      this.ver_mis_asistencias = item.solo_mis_asistencias;
      this.listarPermisosxIdRol(this.id_rol);
      this.listarAccionesXRol(this.id_rol);
      this.bandera = 2;
      this.dialog = true;
    },
    async listarPermisosxIdRol(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      await this.listarModulos();
      axios
        .get("api/Permisos/Listar/" + id, configuracion)
        .then((response) => {
          var index = 0;
          response.data.forEach((element) => {
            index = this.modulos.findIndex((object) => {
              return object.id_modulo == element.id_modulo;
            });
            this.modulos[index].estado = true;
            this.modulos[index].id_permiso = element.id_permiso;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listarAccionesXRol(idRol) {
      axios.get("api/accionesXroles/Listar/" + idRol).then((response) => {
        response.data.forEach((element) => {
          this.items_acciones.push({
            id_acciones_rol: element.id_acciones_rol,
            id_acciones: element.id_acciones,
            idRol: element.idRol,
            estatus: element.estatus,
            nombre: element.nombre_acciones,
          });
        });
      });
    },
    cerrarDialog() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.modulos = [];
      this.items_acciones = [];
      this.nombre = "";
      this.descripcion = "";
      this.condicion = false;
      this.ver_mis_asistencias = false;
    },
    crearRol() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "api/Roles/Crear",
          {
            nombre: this.nombre,
            descripcion: this.descripcion,
            condicion: this.condicion,
            permisos: this.selections,
            accionesRol: this.items_acciones,
            solo_mis_asistencias: this.ver_mis_asistencias
          },
          configuracion
        )
        .then(() => {          
          this.cerrarDialog();
          this.listar();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actualizarRol() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      this.overlay = true;
      axios
        .put(
          "api/Roles/Actualizar",
          {
            idRol: this.id_rol,
            nombre: this.nombre,
            descripcion: this.descripcion,
            condicion: this.condicion,
            solo_mis_asistencias: this.ver_mis_asistencias
          },
          configuracion
        )
        .then(() => {
          this.overlay = false;
          this.actualizarPerfiles();
          this.actualizarAcciones();
        })
        .catch((error) => {
          this.overlay = false;
          console.log(error);
        });
    },
    actualizarPerfiles() {
      //primero se eliminaran todos los permisos y luego se volveran a registrar
      this.modulos.forEach((element) => {
        if (!element.id_permiso && element.estado) {
          this.actualizarPermisos(element.id_modulo);
        }
      });
      this.itemsRemovidos.forEach((element) => {
        if (element.id_permiso) {
          this.eliminarPermisos(element.id_permiso);
        }
      });
      this.listar();
    },
    actualizarAcciones() {
      this.items_acciones.forEach((element) => {
        axios
          .put("api/accionesXroles/Actualizar", {
            id_acciones_rol: element.id_acciones_rol,
            id_acciones: element.id_acciones,
            idRol: element.idRol,
            estatus: element.estatus,
          })
          .then(() => {
            this.cerrarDialog();
            this.listar();
          });
      });
    },
    eliminarPermisos(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .delete("api/Permisos/Eliminar/" + id, configuracion)
        .catch((error) => {
          console.log(error);
        });
    },
    actualizarPermisos(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "api/Permisos/Crear",
          {
            id_modulo: id,
            idRol: this.id_rol,
          },
          configuracion
        )
        .then(() => {})
        .catch((error) => {
          console.log(error);
        });
    },
    removidos(item) {
      if (!item.estado && item.id_permiso) {
        this.itemsRemovidos.push(item);
      } else if (item.estado) {
        this.selections.push(item);
      }
    },
    getColorCondicion(condicion) {
      if (condicion == true) {
        return "green";
      } else {
        return "red";
      }
    },
  },
};
</script>
